import React, { useEffect } from 'react';
import { List, Datagrid, FunctionField } from 'react-admin';

function NuestroParqueList(props: any) {
  useEffect(() => {
    document.title = 'Nuestros Parques - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <FunctionField
          label="Portada"
          render={(record: any) => (
            record.portada ? (
              <img
                src={record.portada.url}
                alt="Portada Parque"
                style={{ width: '120px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
              />
            ) : null
          )}
        />
        <FunctionField
          label="Descripción"
          render={(record: any) => {
            const text = record.descripcion?.[0]?.children?.[0]?.text || "";
            return <span>{text.substring(0, 70)}...</span>;
          }}
        />
      </Datagrid>
    </List>
  );
}

export default NuestroParqueList;